<div class="footer">
	<div class="footertext"> &copy; 2020 | Apcela </div>
</div>